var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { slot: "tool", gutter: 10 }, slot: "tool" },
        [
          _vm.modeEdit
            ? _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-arrow-left", size: "mini" },
                  on: { click: _vm.handleReturn }
                },
                [_vm._v("\n      Retour\n    ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.modeView == "list"
        ? _c("div", [_c("commande-list")], 1)
        : _vm.modeView == "new"
        ? _c("div", [_c("commande-new")], 1)
        : _vm.modeView == "edit"
        ? _c("div", [_c("commande-edit", { attrs: { id: _vm.idCommande } })], 1)
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }